module.exports = __webpack_public_path__ + "static/bigger-purchase-db4e957c704d562144b070f16a9a467c.jpg";